import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableGroupLines = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 10,
	viewBox: "0 0 9 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 0H9V2H0V0ZM0 8H9V10H0V8ZM0 4H6V6H0V4Z",
		fill: "#979797"
	})]
});
const ForwardRef = forwardRef(SvgTableGroupLines);
export { ForwardRef as ReactComponent };
